const motivationalStatements = [
	// Month 1: Action, Courage & Starting Strong (1-31)
	"Believe you can and you're halfway there. Today is yours to conquer!",
	"Action cures fear. Take that first step today, no matter how small.",
	"Do not wait for opportunity. Create it with your efforts today.",
	"Your focus determines your reality. Stay sharp and stay driven.",
	"Make today count. Small progress is still progress.",
	"Energy and persistence conquer all things. Let's get things done!",
	"You are stronger than your excuses. Rise up and take control.",
	"Focus on being productive, not busy. Prioritize what truly matters.",
	"Great things never come from comfort zones. Keep pushing forward.",
	"Start where you are. Use what you have. Do what you can.",
	"Your potential is limitless. Go out there and prove it today.",
	"Be stronger than your strongest excuse. You've got this!",
	"Every day is a fresh start. Write a great chapter today.",
	"Success is the sum of small efforts repeated day in and day out.",
	"Do something today that your future self will thank you for.",
	"The secret of getting ahead is getting started.",
	"Dream big, work hard, and make it happen.",
	"Don't count the days, make the days count.",
	"Focus on the journey, not the destination. Enjoy the growth.",
	"You don't have to be perfect to be amazing. Keep going.",
	"The only limit to our realization of tomorrow is our doubts of today.",
	"Doubt kills more dreams than failure ever will. Believe in yourself.",
	"Make your life a masterpiece; you only get one canvas.",
	"Outwork your self-doubt. Excellence is a habit.",
	"Your focus is your superpower. Channel it into your goals.",
	"Be stubborn about your goals, but flexible about your methods.",
	"The best way to predict the future is to create it.",
	"Do not let what you cannot do interfere with what you can do.",
	"You are entirely up to you. Make yourself proud today.",
	"Rise above the storm and you will find the sunshine.",
	"Every task completed is a step closer to your vision.",

	// Month 2: Productivity, Focus & Momentum (32-60)
	"Keep your momentum high and your distractions low.",
	"You don't need a perfect plan; you just need to start.",
	"Consistency is what transforms average into excellence.",
	"Work hard in silence, let your success be your noise.",
	"The key to productivity is focusing on one thing at a time.",
	"Believe in your capacity to handle whatever comes your way today.",
	"Stay committed to your decisions, but flexible in your approach.",
	"Efficiency is doing things right; effectiveness is doing the right things.",
	"Your mind is for having ideas, not holding them. Get things done!",
	"Do it now. Sometimes 'later' becomes 'never'.",
	"Nothing will work unless you do. Take action today.",
	"You are the author of your own story. Make it a bestseller.",
	"The best preparation for tomorrow is doing your best today.",
	"Keep going. Everything you need will come to you at the perfect time.",
	"Your energy is currency. Spend it well on things that elevate you.",
	"Control your mind, control your day, conquer your goals.",
	"It always seems impossible until it's done.",
	"Productivity is never an accident. It is the result of commitment.",
	"Set your goals high, and don't stop till you get there.",
	"Patience, persistence, and perspiration make an unbeatable combination.",
	"Do not wish for a lighter load; wish for stronger shoulders.",
	"Action is the foundational key to all success.",
	"Your future is created by what you do today, not tomorrow.",
	"Discipline is choosing between what you want now and what you want most.",
	"Believe you can handle the hard days. They build your strength.",
	"Focus on progress, not perfection. Celebrate every win.",
	"You are capable of doing difficult things with grace and strength.",
	"Stay hungry. Stay foolish. Keep pursuing your dreams.",
	"Let your courage be louder than your self-doubt.",

	// Month 3: Confidence, Grit & Persistence (61-90)
	"Confidence comes from taking action. Step up today!",
	"Grit is sticking with your future, day in, day out.",
	"Fall seven times, stand up eight. Persistence wins the day.",
	"You don't have to see the whole staircase, just take the first step.",
	"Your attitude determines your direction. Stay positive.",
	"Be a voice, not an echo. Own your day with confidence.",
	"Success is not final, failure is not fatal: it is the courage to continue that counts.",
	"Believe in your own magic. You have what it takes.",
	"Do not be embarrassed by your failures, learn from them and start again.",
	"Grit beats talent when talent doesn't work hard.",
	"Your time is limited, don't waste it living someone else's life.",
	"Never yield to the pressure. Diamonds are made under pressure.",
	"Keep your face always toward the sunshine, and shadows will fall behind you.",
	"Do not let fear define your limits. Push past them.",
	"Success is walking from failure to failure with no loss of enthusiasm.",
	"You have within you right now, everything you need to succeed.",
	"The only way to do great work is to love what you do.",
	"Be the change you want to see. Lead by example.",
	"No pressure, no diamonds. Embrace the challenge.",
	"Stay strong. Stay focused. Keep moving forward.",
	"Nothing is impossible; the word itself says 'I'm possible!'",
	"Your inner drive is stronger than any external obstacle.",
	"Make your dedication greater than your distraction.",
	"You are the master of your fate, the captain of your soul.",
	"Work hard, be kind, and amazing things will happen.",
	"Do not stop when you are tired. Stop when you are done.",
	"Great goals require great focus. Stay locked in today.",
	"You are built for this. Stay steady and push through.",
	"Every day is another chance to build the life you want.",
	"Let your actions speak louder than your fears.",

	// Month 4: Mental Clarity, Discipline & Daily Mastery (91-120)
	"Mastering others is strength. Mastering yourself is true power.",
	"A clear mind is a powerful mind. Take a deep breath and begin.",
	"Discipline is the bridge between goals and accomplishment.",
	"Keep your priorities straight and your execution flawless.",
	"Focus on execution, not overthinking. Just do it.",
	"You get what you focus on, so focus on what you want.",
	"Your habits define your future. Choose them wisely today.",
	"Simplicity is the ultimate sophistication. Focus on the essentials.",
	"Control the controllable. Let go of the rest.",
	"Your peace of mind is your greatest asset. Protect it.",
	"Success is a series of daily disciplines. Keep the chain going.",
	"You don't find time for things; you make time for them.",
	"The path to success is to take massive, determined action.",
	"Act as if what you do makes a difference. It does.",
	"Your willpower is a muscle. Train it every single day.",
	"Be deliberate with your time and ruthless with your focus.",
	"The trouble is, you think you have time. Make today count.",
	"Success is focusing on one goal until it is accomplished.",
	"Make execution your priority. Ideas are nothing without action.",
	"Rise early, focus deeply, and own your afternoon.",
	"Discipline turns desires into reality.",
	"One day or Day One. You decide.",
	"The best way out is always through.",
	"Do not wait for inspiration. Start working and it will find you.",
	"You are in charge of your mind. Keep it calm and focused.",
	"Focus on what elevates your spirit and productivity.",
	"Stay disciplined. The rewards of hard work are lasting.",
	"Every day is a new canvas. Paint it with purpose.",
	"Your future self is watching. Give them a great show.",
	"Calm waters never made a skilled sailor. Welcome the challenge.",

	// Month 5: Growth Mindset & Inner Strength (121-150)
	"A growth mindset turns obstacles into opportunities.",
	"You are not your mistakes; you are the wisdom gained from them.",
	"Your inner strength is greater than any challenge you face.",
	"Embrace the discomfort of growth. It means you are changing.",
	"Every setback is a setup for a comeback. Keep going.",
	"Learn from yesterday, live for today, hope for tomorrow.",
	"You are capable of adapting, growing, and thriving anywhere.",
	"The capacity to learn is a gift; the ability to learn is a skill.",
	"Growth begins at the end of your comfort zone.",
	"Focus on self-improvement, not self-approval.",
	"Your path may be winding, but your direction is clear.",
	"Believe in the power of yet. You haven't figured it out *yet*.",
	"Be patient with yourself. Nothing in nature blooms all year.",
	"Growth is a slow process, but quitting won't speed it up.",
	"You are a work in progress. Enjoy the construction.",
	"Your potential is like a seed. Give it action to grow.",
	"Stay curious. Stay resilient. Keep expanding your limits.",
	"Do not fear failure; fear being in the exact same place next year.",
	"The only way to fail is to stop trying.",
	"Your strength grows when you think you can't go on, but you do.",
	"Every challenge is a lesson in disguise. Find the wisdom.",
	"Keep evolving. The world needs your unique contribution.",
	"Growth is the only evidence of life. Keep expanding.",
	"Your mind is a garden. Plant seeds of action and focus.",
	"Thrive in the face of change. Adaptability is power.",
	"Invest in your mind. It pays the best interest.",
	"Greatness is a journey of continuous improvement.",
	"You are building a stronger version of yourself every day.",
	"Stay true to your vision and open to growth.",
	"Every step forward is a step toward self-mastery.",

	// Month 6: Resilience, Tenacity & Rising Up (151-180)
	"Resilience is not about bouncing back; it's about growing stronger.",
	"Tenacity is holding on when everyone else has let go.",
	"Rise up. Dust yourself off. Start again with more wisdom.",
	"Your determination is the shield against any setback.",
	"Stay tough when the road gets rough. Persistence pays.",
	"Every storm runs out of rain. Stay steady and push through.",
	"Your capacity to endure is greater than you know.",
	"Do not let temporary defeats define your permanent potential.",
	"Hard times build determination that last a lifetime.",
	"Keep your head high and your heart strong.",
	"The harder the conflict, the more glorious the triumph.",
	"You are not defeated until you quit. Keep going.",
	"Let your resilience inspire those around you.",
	"Grit is the extra margin that separates success from failure.",
	"Every trial is testing your resolve. Pass the test today.",
	"Be like a postage stamp: stick to one thing until you get there.",
	"Nothing can dim the light that shines from within.",
	"Your tenacity is your ticket to achieving your dreams.",
	"Embrace the grind. It is where character is forged.",
	"Stay focused, stay calm, and execute with precision.",
	"The only limit is the one you set in your mind.",
	"Never allow fear to dictate your actions.",
	"Keep climbing. The view is always better from the top.",
	"You have the heart of a champion. Let it show today.",
	"Resilience is the hallmark of every great achiever.",
	"Stay persistent. The breakthrough is closer than you think.",
	"Never give up on a dream just because of the time it will take.",
	"Your drive is unstoppable when you believe in your purpose.",
	"Rise to the challenge and make today extraordinary.",
	"Stand firm in your goals and stay relentless in your pursuit.",

	// Month 7: Courage, Boldness & Defeating Fear (181-210)
	"Courage is not the absence of fear, but the triumph over it.",
	"Be bold enough to design your own life path.",
	"Defeat your fears by taking immediate action.",
	"Fear is only as deep as the mind allows. Break through it.",
	"A bold step forward changes everything. Take it today.",
	"Do not let fear decide your future. You are in control.",
	"Courage is taking action when you are afraid.",
	"Speak your truth, walk your path, and own your journey.",
	"Bold decisions lead to beautiful destinations.",
	"Fear is temporary. Regret is permanent. Choose action.",
	"Face your fears and they will lose their power over you.",
	"Be brave. Even if you're not, pretend to be.",
	"Your courage is your compass. Let it guide you today.",
	"Do not let the fear of losing block the joy of winning.",
	"Boldly go in the direction of your dreams.",
	"Courage is like a muscle. We strengthen it by use.",
	"Fear of failure is a mirage. Drive right through it.",
	"You have the power to face any obstacle with courage.",
	"Step out of the shadows of doubt. Walk in bold confidence.",
	"Your life expands or contracts in proportion to your courage.",
	"Be daring. Be different. Be relentless.",
	"Fear is a liar. Keep moving forward.",
	"Courage starts with showing up and letting yourself be seen.",
	"Boldness has genius, power, and magic in it.",
	"Do not let fear of the unknown hold you back.",
	"Take the risk. If you win, you're happy. If you lose, you're wise.",
	"Stand tall, step forward, and conquer your doubts.",
	"Your bravery today defines your success tomorrow.",
	"Choose courage over comfort every single day.",
	"Relentless actions silence all fears.",

	// Month 8: Focus, Execution & High Achievement (211-240)
	"High achievers focus on execution. Make it happen today.",
	"Let your performance speak for your commitment.",
	"Great execution turns simple ideas into massive success.",
	"Focus on results, not efforts. Deliver high quality today.",
	"Your standards define your success. Keep them high.",
	"Execution is the ultimate differentiator. Make your mark.",
	"High achievement requires high focus. Block the noise.",
	"Aim for excellence in every single task you touch.",
	"Success is not about luck; it's about deliberate execution.",
	"Your work ethic is the foundation of your success.",
	"Deliver value, execute flawlessly, and stand out.",
	"The distance between dreams and reality is called action.",
	"Keep your eyes on the prize and execute with precision.",
	"High achievers do not wait; they take initiative.",
	"Success belongs to those who execute consistently.",
	"Make your execution so good it cannot be ignored.",
	"Your consistency is the key to unlocking your potential.",
	"Focus on your vision and execute without hesitation.",
	"Let your dedication be your driving force today.",
	"Aim high, execute deliberately, and achieve greatness.",
	"The secret to winning is executing the fundamentals perfectly.",
	"Deliver your best effort in everything you do.",
	"Your commitment is the engine of your achievement.",
	"Stay locked in. Your focus is your competitive edge.",
	"Execution beats theory every single time.",
	"High standards produce high results. Never settle.",
	"Focus on your goals like your future depends on it.",
	"Your daily execution builds your lifetime achievement.",
	"Relentless execution is the pathway to mastery.",
	"Make today a masterpiece of productivity and focus.",

	// Month 9: Ownership, Responsibility & Integrity (241-270)
	"Take extreme ownership of your life, actions, and results.",
	"Your success is your responsibility. Own your destiny.",
	"Integrity is doing the right thing when no one is watching.",
	"Accept responsibility for your life. You are the creator.",
	"Own your mistakes, learn from them, and move forward.",
	"Your choices define your character. Choose integrity.",
	"Take charge of your day. Do not let circumstances control you.",
	"Integrity is the foundation of trust and success.",
	"Own your goals, own your actions, and celebrate your wins.",
	"You are responsible for your own happiness and success.",
	"Let your actions align with your values today.",
	"Extreme ownership leads to extreme results. Take charge.",
	"Your word is your bond. Deliver on your promises.",
	"Take responsibility for your progress. Keep pushing.",
	"Integrity brings peace of mind and lasting success.",
	"Own your journey. No excuses, no blame, just action.",
	"Your character is your destiny. Build it with integrity.",
	"Responsibility is the price of greatness. Own your power.",
	"Let your execution show your level of ownership.",
	"Own your day. Make decisions that empower your vision.",
	"Integrity is choosing courage over comfort.",
	"Your actions are your true signature. Sign them with pride.",
	"Take ownership of your mindset. Stay positive and driven.",
	"Responsibility builds strength and commands respect.",
	"Integrity is the highest form of self-respect.",
	"Own your growth. No one else can do the work for you.",
	"Let your integrity guide your decisions today.",
	"Take charge of your life and make no room for excuses.",
	"Extreme ownership turns obstacles into triumphs.",
	"Live with integrity, act with purpose, and own your results.",

	// Month 10: Determination, Vision & Ultimate Success (271-300)
	"Determination is the wake-up call to the human will.",
	"Keep your vision clear and your resolve unbreakable.",
	"Ultimate success is the result of relentless determination.",
	"Let your vision pull you forward on the hard days.",
	"Determined action defeats any obstacle in your path.",
	"Your vision is your roadmap. Stay true to it today.",
	"Success is not for the faint-hearted. Stay determined.",
	"Let your resolve be stronger than any distraction.",
	"Your vision determines your focus; your focus determines your success.",
	"Stay determined. The finish line is worth the climb.",
	"A clear vision gives purpose to your daily grind.",
	"Relentless determination is the key to unlocking your dreams.",
	"Keep your eyes on the horizon and your feet moving forward.",
	"Your vision is a preview of your life's coming attractions.",
	"Determination is the fuel that keeps you moving toward your goals.",
	"Believe in your vision, even when others cannot see it.",
	"Stay determined, stay focused, and achieve what you set out to do.",
	"Your vision is worth the hard work and sacrifice. Keep going.",
	"Determination turns obstacles into stepping stones.",
	"Keep your vision alive with daily, determined action.",
	"Relentless determination overcomes any temporary setback.",
	"Your vision is your promise to your future self.",
	"Determination is the key to mastering your own destiny.",
	"Keep your focus sharp, your vision clear, and your resolve strong.",
	"Ultimate success belongs to those who refuse to give up.",
	"Let your determination be your signature trait today.",
	"Your vision is the architecture of your future. Build it well.",
	"Relentless resolve leads to remarkable results.",
	"Stay determined and make your vision a reality.",
	"Success is the natural result of determined, focused effort.",

	// Month 11: Action, Speed & Continuous Execution (301-330)
	"Action is the antidote to anxiety. Start executing now.",
	"Speed of execution is your greatest competitive advantage.",
	"Continuous execution builds momentum. Keep the pace.",
	"Do not wait for the perfect moment. Take the moment and make it perfect.",
	"Speed beats hesitation. Act decisively today.",
	"Continuous action leads to continuous improvement.",
	"Hesitation is the enemy of progress. Move forward now.",
	"Speed of implementation is the key to rapid growth.",
	"Take action today and adjust your course along the way.",
	"Continuous effort is the key to unlocking your potential.",
	"decisive action creates decisive results. Step up.",
	"Speed up your execution and leave hesitation behind.",
	"Continuous execution is the pathway to massive achievement.",
	"Take the initiative. Do not wait to be told what to do.",
	"Speed and precision make an unbeatable combination.",
	"Continuous action silences doubt and builds confidence.",
	"Hesitation is a dream killer. Act now with bold resolve.",
	"Speed of execution shows your commitment to your goals.",
	"Continuous effort beats temporary talent every single time.",
	"Take action with bold confidence and watch the obstacles fade.",
	"Speed up your progress by executing immediately.",
	"Continuous action turns your dreams into daily reality.",
	"Decisive execution is the ultimate power move.",
	"Speed of action creates opportunities that hesitation misses.",
	"Continuous execution is the engine of high performance.",
	"Take action today and build the momentum you need.",
	"Speed beats perfection. Start now and refine as you go.",
	"Continuous effort is the secret to lasting mastery.",
	"Act decisively, execute rapidly, and achieve consistently.",
	"Continuous execution is the key to owning your day.",

	// Month 12: Success, Celebration &Relentless Focus (331-365)
	"Success is the natural byproduct of relentless focus.",
	"Celebrate your progress, but stay hungry for more.",
	"Relentless focus is the key to achieving your ultimate goals.",
	"Success is a journey, not a destination. Enjoy the growth.",
	"Keep your focus sharp and your goals in sight.",
	"Celebrate your wins, learn from your losses, and keep moving.",
	"Relentless pursuit of excellence is the only way to win.",
	"Success is built on daily disciplines and focused execution.",
	"Keep your eyes on the prize and let nothing distract you.",
	"Celebrate your strength, your grit, and your determination.",
	"Relentless execution is the foundation of ultimate success.",
	"Success is not about being the best; it's about being your best.",
	"Keep your momentum high and your focus unbroken today.",
	"Celebrate the journey and the person you are becoming.",
	"Relentless determination is the ticket to your dreams.",
	"Success is the sum of small wins repeated daily.",
	"Keep your focus locked in and execute with pride.",
	"Celebrate your resilience and your capacity to grow.",
	"Relentless focus turns obstacles into opportunities.",
	"Success belongs to those who refuse to settle for less.",
	"Keep your goals clear and your execution flawless.",
	"Celebrate your progress and keep pushing for greatness.",
	"Relentless resolve is the pathway to your vision.",
	"Success is a habit, not a one-time event. Keep it up.",
	"Keep your focus sharp, your resolve strong, and your heart open.",
	"Celebrate your achievements and set your sights higher.",
	"Relentless execution is the key to mastering your day.",
	"Success is the natural result of focused, determined action.",
	"Keep your momentum high and let your actions speak.",
	"Celebrate your grit, your persistence, and your vision.",
	"Relentless pursuit of your goals leads to ultimate victory.",
	"Success is built one day, one task, and one win at a time.",
	"Keep your focus locked, execute flawlessly, and conquer your day.",
	"Celebrate your journey and look forward to the road ahead.",
	"A year of relentless focus, ultimate execution, and great success. Keep winning!"
];

export default motivationalStatements;
